import { useGroupDirectory, useMyPendingInvites } from '@echo/core/react';
import { Trans } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';
import { GroupDashboardList } from '@/components/group-dashboard';
import { GroupLoadFailed, GroupLoading } from '@/components/group-load-state';
import { NoGroups } from '@/components/no-groups';
import { PendingInvitesCard } from '@/components/pending-invites-card';

export const Route = createFileRoute('/_app/groups')({ component: GroupsPage });

/** Groups tab opens a shared group profile; Account retains group management. */
function GroupsPage() {
  const mine = useGroupDirectory();
  const list = mine.data ?? [];
  const invites = useMyPendingInvites().data ?? [];

  // Wait for the list before saying there are none.
  if (mine.isPending) return <GroupLoading />;
  if (mine.isError) return <GroupLoadFailed onRetry={() => void mine.refetch()} />;
  return (
    <>
      <h1 className="text-display-sm font-bold">
        <Trans>Groups</Trans>
      </h1>
      <div className="flex flex-col gap-content-lg pt-content-lg">
        <PendingInvitesCard invites={invites} />
        {list.length ? (
          <GroupDashboardList groups={list} onRetryDetails={(id) => void mine.retryDetails(id)} />
        ) : invites.length ? null : (
          <NoGroups
            body={
              <Trans>
                Groups let you do the program alongside family, friends or others. When someone
                invites you to one, it will appear here.
              </Trans>
            }
          />
        )}
      </div>
    </>
  );
}
